import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAdminAuthUser } from '../../services/storage/adminFlow';
import { isAdminRole, isSuperAdminRole } from '../../services/api/admin';
import { getCurrentSessionHomeRoute } from '../../utils/companyOwner';
import { nextStageForAdmin } from '../../utils/adminOnboarding';

interface AdminRouteProps {
  requireSuperAdmin?: boolean;
  deniedArea?: string;
}

const AdminRoute: React.FC<AdminRouteProps> = ({
  requireSuperAdmin = false,
  deniedArea = 'admin',
}) => {
  const location = useLocation();
  const adminUser = getAdminAuthUser();

  if (!adminUser || !isAdminRole(adminUser.roles)) {
    return (
      <Navigate
        replace
        state={{ from: location }}
        to={getCurrentSessionHomeRoute() ? '/access-denied?area=admin' : '/login'}
      />
    );
  }

  if (nextStageForAdmin(adminUser) !== 'completed') {
    return (
      <Navigate
        replace
        state={{ from: location }}
        to="/admin/onboarding"
      />
    );
  }

  if (requireSuperAdmin && !isSuperAdminRole(adminUser.roles)) {
    return (
      <Navigate
        replace
        state={{ from: location }}
        to={`/access-denied?area=${encodeURIComponent(deniedArea)}`}
      />
    );
  }

  return <Outlet />;
};

export default AdminRoute;
